'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LiveCatalogStatusRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transformPost = function transformPost(body) {
    var _body$data = body.data,
        approved = _body$data.Approved,
        catalog = _body$data.Auction;

    var _ref = catalog || {},
        description = _ref.AuctionDescription,
        catalogId = _ref.AuctionId,
        title = _ref.AuctionTitle,
        currentItem = _ref.CurrentLot,
        lastUpdated = _ref.LastUpdated,
        itemCount = _ref.LotCount;

    var _ref2 = currentItem || {},
        itemId = _ref2.LotId,
        lotNumber = _ref2.LotNumber,
        lotTitle = _ref2.LotTitle,
        lotDescription = _ref2.LotDescription,
        askPrice = _ref2.AskPrice,
        leadingBidder = _ref2.LeadingBidderId,
        lowEstimate = _ref2.LowEstimate,
        leadingBid = _ref2.HighBid,
        highEstimate = _ref2.HighEstimate,
        reserverPrice = _ref2.ReservePrice;

    return {
        data: {
            approved: approved,
            catalogId: catalogId,
            currentItem: {
                askPrice: askPrice,
                highEstimate: highEstimate,
                itemId: itemId,
                leadingBid: leadingBid,
                leadingBidder: leadingBidder,
                lotDescription: lotDescription,
                lotNumber: lotNumber,
                lotTitle: lotTitle,
                lowEstimate: lowEstimate,
                reserverPrice: reserverPrice
            },
            description: description,
            itemCount: itemCount,
            lastUpdated: lastUpdated,
            status: !!currentItem.LotId ? 'live' : 'online',
            title: title
        }
    };
};

var transformGet = function transformGet(body) {
    var _body$data2 = body.data,
        approved = _body$data2.Approved,
        description = _body$data2.AuctionDescription,
        catalogId = _body$data2.AuctionId,
        title = _body$data2.AuctionTitle,
        currentItem = _body$data2.CurrentLot,
        lastUpdated = _body$data2.LastUpdated,
        itemCount = _body$data2.LotCount;

    var _ref3 = currentItem || {},
        itemId = _ref3.LotId,
        itemIndex = _ref3.LotIndex,
        lotNumber = _ref3.LotNumber,
        lotTitle = _ref3.LotTitle,
        lotDescription = _ref3.LotDescription,
        askPrice = _ref3.AskPrice,
        leadingBidder = _ref3.LeadingBidderId,
        lowEstimate = _ref3.LowEstimate,
        leadingBid = _ref3.HighBid,
        highEstimate = _ref3.HighEstimate,
        reserverPrice = _ref3.ReservePrice;

    return {
        data: {
            approved: approved,
            catalogId: catalogId,
            currentItem: {
                askPrice: askPrice,
                highEstimate: highEstimate,
                itemId: itemId,
                itemIndex: itemIndex,
                leadingBid: leadingBid,
                leadingBidder: leadingBidder,
                lotDescription: lotDescription,
                lotNumber: lotNumber,
                lotTitle: lotTitle,
                lowEstimate: lowEstimate,
                reserverPrice: reserverPrice
            },
            description: description,
            itemCount: itemCount,
            lastUpdated: lastUpdated,
            status: !!currentItem.LotId ? 'live' : 'online',
            title: title
        }
    };
};

var LiveCatalogStatusRemote = exports.LiveCatalogStatusRemote = {
    fetchLiveCatalogStatus: function fetchLiveCatalogStatus(_ref4) {
        var Token = _ref4.authToken,
            bidderId = _ref4.bidderId,
            AuctionId = _ref4.catalogId,
            deployment = _ref4.deployment,
            Email = _ref4.email,
            Source = _ref4.source;
        return new _promise2.default(function (resolve, reject) {
            var shouldPost = !!bidderId && !!Email;
            var requestFuction = shouldPost ? _helpers.makePost : _helpers.makeGet;
            var request = requestFuction({
                authToken: Token,
                deployment: deployment,
                path: '<CLERK-SERVICE>clerk/auction/' + AuctionId
            });

            if (bidderId && Email) {
                request.send({
                    AuctionId: AuctionId,
                    Email: Email,
                    Source: Source,
                    Token: Token
                });
            }

            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({
                    err: err,
                    reject: reject,
                    resolve: resolve,
                    response: response,
                    success404: true,
                    transform: shouldPost ? transformPost : transformGet
                });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/liveCatalogStatus.js
// module id = grTh
// module chunks = 60